module.exports = __webpack_public_path__ + "media/images/blank-a2891b14f17202b45976cc46e745331a.png";